// services/childTransferApi.js
import apiClient from './apiClient';

export const childTransferApi = {
  // Временное перемещение детей
  async addTemporaryTransfer(transferData) {
    const data = {
      kg_to: transferData.targetKindergarten,
      gr_to: transferData.targetGroup,
      gr_from: transferData.currentGroup,
      childrens: {
        [transferData.childId]: true
      },
      name_doc: transferData.documentName,
      number_doc: transferData.orderNumber,
      date_doc: transferData.orderDate,
      placeType: transferData.placeType,
      gr_to_number: transferData.targetGroupNumber,
      scan_doc: transferData.scan_doc // ID загруженного документа
    };

    const response = await apiClient.post('chmove_temp', data);
    return response.data;
  },

  // Удаление временного перемещения
  async removeTemporaryTransfer(removeData) {
    const data = removeData.map(item => ({
      childId: item.childId,
      tempMoved: item.tempMoved,
      gr_from: item.currentGroup
    }));

    const response = await apiClient.delete('chmove_temp', data);
    return response.data;
  },

  // Получение временно перемещенных детей
  async getTemporaryTransferredChildren(kgId, grId = null) {
    const url = grId 
      ? `chmove_temp/${kgId}/${grId}`
      : `chmove_temp/${kgId}`;
    
    const response = await apiClient.get(url);
    return response.data;
  },

  // Получение детей, перемещенных ИЗ указанного садика
  async getChildrenTransferredFrom(kindergartenId, groupId = null) {
    const url = groupId
      ? `chmove_temp/from/${kindergartenId}/${groupId}`
      : `chmove_temp/from/${kindergartenId}`;
    
    const response = await apiClient.get(url);
    return response.data;
  }
};

export default childTransferApi;